const isValidEmail = "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+[a-zA-Z0-9-.]+$";

export const validateEmail = (email: String) => {
    const test = email.match(isValidEmail);
    return(test != null && test.length > 0);
}